type Parameters = {
  webAudioId: string;
};

export async function createWaveformData({
  webAudioId,
}: Parameters): Promise<Response> {
  try {
    const response = await fetch(
      `/api/proxy/v3/audios/webAudioId:${webAudioId}/waveform`,
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      }
    );
    if (response.ok) return response;
    throw new Error('Unable to generate waveform data');
  } catch (err) {
    throw new Error(err.message);
  }
}
